import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css';
//import 'swiper/css/bundle';

export default class Sliders {

  hero() {
    new Swiper(".hero-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      //effect: 'fade',
      //crossFade: true,
      pagination: {
        el: ".hero-slider-pagination",
        clickable: true
      },
      navigation: {
        prevEl: '.hero-slider-prev',
        nextEl: '.hero-slider-next',
      },
      autoplay: {
  			delay: 5000,
  		},
      speed: 2000,
    });
  }

  gallery() {
    new Swiper(".gallery-slider", {
      loop: true,
      autoHeight: false,
      preloadImages: false,
      lazy: true,
      centeredSlides: true,
      spaceBetween: 4,
      navigation: {
        prevEl: '.gallery-slider-prev',
        nextEl: '.gallery-slider-next',
      },
      autoplay: {
  			delay: 2000,
        disableOnInteraction: true
  		},
      speed: 1000,
      //freeModeMomentum: false,
    });
  }

  
  init() {
    document.querySelector('.hero-slider') ? this.hero() : null;
    document.querySelector('.gallery-slider') ? this.gallery() : null;
  }
}